import { getPaymentPlanByExternalId, patchCancelPaymentPlanById, PaymentPlan } from '@nemuru-eng/js-api-client';

import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

export const usePaymentPlan = (paymentPlan: PaymentPlan) => {
  const { request, loading } = useRequest();
  const { revalidate } = useCache(getPaymentPlanByExternalId, { externalId: paymentPlan.externalId });

  const cancelPaymentPlanById = async () => {
    await request(patchCancelPaymentPlanById, { id: paymentPlan.id });
    await revalidate();
  };

  return { cancelPaymentPlanById, loading };
};
